<template>
  <v-card class="card-base card" @click="clickHandler">
    <div class="card__title">
      <v-icon class="card__icon" size="25">{{ mdiPlaylistPlus }}</v-icon>
      <span>{{ title }}</span>
    </div>
    <div class="card__text">{{ text }}</div>
  </v-card>
</template>

<script>
import { mdiPlaylistPlus } from '@mdi/js';

import { AuthModule } from '@/store/modules/auth';
import { RouteName } from '@/router';

export default {
  name: 'NotariusActionCard',
  props: {
    statementType: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    mdiPlaylistPlus,
  }),
  methods: {
    clickHandler() {
      if (AuthModule.isAuthenticated) {
        this.$router.push({ name: RouteName[this.statementType] });
      } else {
        AuthModule.login();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  padding: 20px 18px;
  margin-bottom: 38px;

  @media screen and (max-width: $gr-md) {
    margin-bottom: 0;
    width: 100%;
  }

  &:hover {
    box-shadow: none;
    cursor: pointer;
  }

  &__link {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }

  &__title {
    color: $color-base;
    font-size: $font-size-middle-level-2;
    display: flex;
    align-items: center;
    border-bottom: 1px solid $color-dark-grey;
    padding-bottom: 10px;
    height: 116px;

    span {
      line-height: 20px;
    }
  }

  &__text {
    color: $color-dark-grey;
    font-size: $font-size-small;
    padding-top: 10px;
  }

  &__icon {
    color: $color-base;
    margin-right: 11px;

    svg {
      fill: $color-base;
    }
  }
}
</style>
